<template>
    <InputRangeTwoKnobbed
        v-model="model"
        v-qa="'range-exponential'"
        :data-qa-min="bounds.min"
        :data-qa-max="bounds.max"
        :data-qa-steps="steps"
        :data-qa-bounds="JSON.stringify(bounds)"
        :data-qa-value="JSON.stringify(modelValue)"
        :data-qa-linear-config="JSON.stringify(linearConfig)"
        :min="0"
        :max="steps"
        :value-formatter="formatter"
        :max-label
        :min-label
    />
</template>

<script setup lang="ts">
import { computed, useModel } from 'vue'
import InputRangeTwoKnobbed from '@/components/ui/inputs/range/InputRangeTwoKnobbed.vue'
import type { LinearConfig } from 'wucdbm-exponential-slider'
import { useExponentialSlider } from '@/composables/exponential-slider'
import {
    defaults,
    type Props,
} from '@/components/ui/inputs/range/input-range-exponential-ok-props.ts'

const props = withDefaults(defineProps<Props>(), defaults)

const linearConfig = computed((): LinearConfig => {
    return {
        linearPercent: props.linearPercent,
        maxLinear: props.maxLinear,
    }
})

const { model, formatter } = useExponentialSlider(
    useModel(props, 'modelValue'),
    () => props.steps,
    () => props.bounds,
    linearConfig,
    props.valueFormatter,
    true
)
</script>
